import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { sanity, imageUrlBuilder } from "../client.js";
import { motion } from "framer-motion";
const Carousel = () => {
	const [carouselData, setCarouselData] = useState(null);

	useEffect(() => {
		sanity
			.fetch(
				`*[_type == "projects"]|order(_createdAt asc){
			title,
			description,
			IphoneImage,
			link,
			colortheme,
		}`
			)
			.then((data) => setCarouselData(data))
			.catch(console.error);
	}, []);

	const [width, setWidth] = useState(0);
	const carousel = useRef();
	useEffect(() => {
		setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
	}, [carouselData]);

	return (
		<StyledCarousel ref={carousel}>
			<motion.div
				className="carousel-container"
				drag="x"
				dragConstraints={{ right: 0, left: -width }}
				whileTap={{ cursor: "grabbing" }}
			>
				{carouselData &&
					carouselData.map((carousel, index) => (
						<motion.div
							className="carousel-card"
							key={index}
							style={{ background: carousel.colortheme }}
						>
							<h3>{carousel.title}</h3>
							<p>{carousel.description}</p>
							<img
								src={
									imageUrlBuilder
										.image(carousel.IphoneImage)
										.url() || ""
								}
								alt={carousel.title}
							/>

							<a href={carousel.link}>View &#62; </a>
						</motion.div>
					))}
			</motion.div>
		</StyledCarousel>
	);
};

export default Carousel;

const StyledCarousel = styled(motion.div)`
	overflow: hidden;
	border-radius: 8px;
	margin-top: 64px;
	@media (min-width: 750px) {
		margin-right: 30%;
		margin-left: 30%;
	}
	@media (min-width: 1000px) {
		margin-right: 18%;
		margin-left: 18%;
	}
	.carousel-container {
		padding-left: 16px;
		display: inline-flex;
		cursor: grab;

		gap: 16px;
		.carousel-card {
			align-self: stretch;
			width: 300px;

			background-color: rgba(169, 121, 221, 1);
			color: white;
			padding: 32px 32px 0 32px;
			border-radius: 8px;
			position: relative;
			display: flex;
			flex-direction: column;
			gap: 16px;
			h3 {
				font-size: 1.2rem;
				text-transform: capitalize;
				@media (min-width: 1000px) {
					font-size: 1.5rem;
				}
			}
			p {
				font-size: 0.8rem;
				max-height: 90px;
				text-overflow: ellipsis;
				overflow: hidden;
				margin-bottom: auto;

				@media (min-width: 1000px) {
					line-height: 1.5;
					font-size: 0.8rem;
					max-height: max-content;
					// border: solid;
					overflow: revert;
					width: 70%;
				}
			}

			a {
				position: absolute;
				text-decoration: none;
				color: inherit;
				bottom: 32px;
				right: 32px;
				opacity: 0.5;
			}
			img {
				width: 150px;
			}

			@media (min-width: 1000px) {
				width: 380px;
				height: 500px;

				gap: 32px;
			}
		}
	}
`;
